import React, { useEffect, useState } from "react";
import NotFoundPage from "../components/general/NotFound";
import { useUser } from "../util/user";
import OverviewContent from "./../components/overview/OverviewContent";
import { useRouter } from "./../util/router";

function OverviewPage() {
  const [hasAccess, setHasAccess] = useState(false);
  const router = useRouter();
  const userObj = useUser();

  useEffect(() => {
    if (userObj != null) {
      if (userObj.roles != null && userObj.roles.includes("overview:_view"))
        setHasAccess(true);
    }
    else
      router.push("/solar/logout");
  }, [userObj]);

  return (
    <>{hasAccess ? <OverviewContent /> : <NotFoundPage />}</>
  );
}

export default OverviewPage;
